export default function smoothScroll() {
  document.addEventListener('click', function (event) {
    const clickedElement = event.target;
    if (clickedElement.tagName === 'A' && clickedElement.getAttribute('href').indexOf('#') !== -1) {
      const time = 400;
      const header = document.querySelector('header').offsetHeight;
      const target = document.querySelector(clickedElement.hash);
      if (!target) return;
      const targetY = target.getBoundingClientRect().top + window.pageYOffset - header;
      window.scrollTo({ top: targetY, behavior: 'smooth' });
      event.preventDefault();
    }
  });
}
